export const satisfactionSurvey = {
	title: "Encuesta de satisfacción",
	periodData: {
		thirty: "Últimos 30 días",
		sixty: "Últimos 60 días",
		ninety: "Últimos 90 días",
		rangeFormat: "{{sinceDay}} de {{sinceMonth}} al {{untilDay}} de {{untilMonth}}",
		period: "Período",
		custom: "Período personalizado",
		placeholder: "Seleccione el período",
	},
	tabs: {
		results: "Resultados",
		shareSettings: "Configuraciones y compartir",
		searchSettings: "Configuraciones de encuesta",
		newPlaceAvailable: "Nuevo local disponible",
		smsReport: "Informe de inversión",
	},
	formatQuestionType: {
		service: "Servicio / Atención",
		product: "Producto",
		mixes: "Variedad del menú",
		cleaness: "Limpieza",
		price: "Precio",
		music: "Música",
		nps: "NPS",
		paymentExperience: "Experiencia de pago",
	},
	results: {
		columns: {
			birthDate: "Fecha de Nacimiento",
			client: "Cliente",
			date: "Fecha",
			document: "Documento",
			averageTicket: "Ticket promedio",
			phone: "Teléfono",
			ratingDate: "Fecha de evaluación",
			comment: "Comentario",
		},
		fileTitle: "Historial de evaluaciones por evento",
		filename: "evaluaciones-nps",
		customerAnswer_one: "{{totCustomers}} cliente respondió la encuesta de satisfacción",
		customerAnswer_other:
			"{{totCustomers}} clientes respondieron la encuesta de satisfacción",
		lastDays_one: "en el último {{days}} día",
		lastDays_other: "en los últimos {{days}} días",
		filterPlaceholder: "Filtre por local",
		searchClientPlaceholder: "Buscar por nombre o RFC",
		export: "Exportar a Excel",
		resultsEvent: "Resultado de la encuesta por evento",
		emptyStateTitle: "Local no habilitado",
		emptyStateDescription:
			"Este local no está habilitado para recibir respuestas de la encuesta de satisfacción. Contacte al equipo de Zig para activar este servicio.",
		popover: {
			answer_one: "{{totalAnswers}} evaluación",
			answer_other: "{{totalAnswers}} evaluaciones",
			client_one: "{{count}} cliente",
			client_other: "{{count}} clientes",
			opinion_one: "{{count}} opinión",
			opinion_other: "{{count}} opiniones",
		},
		drawer: {
			title: "Detalles de la experiencia",
			event: "Evento",
			date: "Fecha",
			consumedProducts: "Productos consumidos",
			assessment: "Evaluación",
			stars_one: "{{value}} estrella",
			stars_other: "{{value}} estrellas",
			answerNps:
				"De 1 a 10, la probabilidad de que este cliente recomiende {{name}} a amigos y familiares es",
			client: "Cliente",
			cpf: "RFC",
			phone: "Teléfono",
			birthDate: "Fecha de nacimiento",
		},
	},
	shareSettings: {
		title: "Configuraciones de compartir",
		content:
			"Es muy importante definir los medios de activación del cliente para que pueda tener una retroalimentación justa de su organización.",
		qrCodeSection: {
			title: "Código QR en la mesa / salón",
			description:
				"Haga clic en el botón abajo para descargar e imprimir el código QR que llevará a su cliente al enlace de la encuesta de satisfacción.",
			downloadButton: "Descargar código QR",
		},
		smsSection: {
			title: "SMS manual",
			description:
				"Copie el enlace abajo y envíe un mensaje a la lista de clientes seleccionada por usted. Solo debe ir a la sección de mensajes en el área del cliente.",
			copyButton: "Copiar enlace de encuesta",
			cancelUpdates: "Cancelar cambios",
			saveUpdates: "Guardar cambios",
			dailyLimit: {
				label: "Límite de SMS diario",
				tooltip: "El valor cobrado por SMS enviado consta en su contrato.",
				description: "Este será el límite para envíos automáticos del enlace.",
			},
		},
		modal: {
			qrCode: "Descargar código QR",
			qrCodeDescription: "Haga clic aquí para abrir el código QR",
			link: "Copiar enlace",
			linkDescription: "Haga clic para copiar el enlace de la encuesta",
			downloadAllQRCode: "Descargar todos los códigos QR",
			rowModal: {
				qrCode:
					'No hay ningún local habilitado. Para descargar el código QR de esta encuesta, debe activarla en la pestaña "Configuraciones de encuesta"',
				link:
					'No hay ningún local habilitado. Para generar un enlace para la encuesta de satisfacción, debe activarla en la pestaña "Configuraciones de encuesta"',
			},
		},
	},
	searchSettings: {
		emptyState: {
			title: "Ningún local habilitado",
			description:
				"No se encontró local habilitado para configurar la encuesta de satisfacción. Contacte al equipo de Zig para activar este servicio.",
		},
		title: "Configuraciones de encuesta",
		description:
			"Elija cuáles son los parámetros que desea que sus clientes evalúen por local.",
		cancelButton: "Cancelar cambios",
		saveButton: "Guardar cambios",
		new: "Nuevo",
		successNotification: "Las configuraciones de encuesta fueron actualizadas",
		shouldSendSmsOnCheckout:
			"Enviar SMS de NPS automáticamente a todos los clientes después del checkout",
	},
	customModal: {
		successNotification: "Enlace de la encuesta copiado",
	},
	smsReport: {
		filterByPlace: "Filtre por local",
		filterByDate: "Fecha del Evento",
		columns: {
			date: "Fecha del Evento",
			smsSentCount: "SMS enviados",
			npsAnswersCount: "Respuestas",
			conversion: "Tasa de conversión por SMS",
		},
		totalizers: {
			smsSents: "SMS enviados",
			npsFormAnswers: "Total de respuestas",
			checkins: "Tasa de conversión total",
		},
	},
};
